import * as React from 'react';
import './HTMLEditorQuillHide.css';
import { FunctionComponent } from 'react';
import { HTMLEditorQuill } from './HTMLEditorQuill';
import { AppUser } from 'Src/views/App/App';

interface Props {
  user?: AppUser;
  onTextChange: (editorState: any) => void;
  value: string;
  isEnabled: boolean;
  placeholder?: string;
}

export const HTMLEditorQuillHide: FunctionComponent<Props> = props => {
  return (
    <HTMLEditorQuill
      user={props.user}
      onEmailBodyChange={props.onTextChange}
      value={props.value}
      isEnabled
      isToolbarVisible={props.isEnabled}
      placeholder={props.placeholder}
    />
  );
};

HTMLEditorQuillHide.displayName = 'HTMLEditorQuillHide';
